import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useRef, useEffect } from 'react';
import './App.css';
import './CSS/fichier.css';
import './CSS/footer.css';
import usePageTracking from "./hooks/usePageTracking";
import '@fontsource/montserrat/300.css'; // Light
import '@fontsource/montserrat/400.css'; // Regular
import '@fontsource/montserrat/500.css'; // Medium
import '@fontsource/montserrat/600.css'; // Semi-Bold
import '@fontsource/montserrat/700.css'; // Bold
import "@fortawesome/fontawesome-free/css/all.min.css";
import { LanguageProvider } from "./hooks/LanguageContext";



import Header from './components/composant_reutilisable/Header';
import Navbar from './components/composant_reutilisable/Navbar';
import Footer from './components/composant_reutilisable/Footer';
import Accueil from "./components/composant_navbar/Accueil";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Visiter from "./components/composant_navbar/Visiter";
import Ambassade from "./components/composant_navbar/Ambassade";
import Equipe_diplomatique from "./components/composant_navbar/Equipe_diplomatique";
import Consulat_honoraires from "./components/composant_navbar/Consulat_honoraires";
import Articles from "./components/composant_navbar/Articles";
import Compte_rendus from "./components/composant_navbar/Compte_rendus";
import Communiques from "./components/composant_navbar/Communiques";
import Services from "./components/composant_navbar/Services";
import Cooperation_bilateral from "./components/composant_navbar/Cooperation_bilateral";
import Cooperation_multilaterales from "./components/composant_navbar/Cooperation_multilaterales";
import Investir from "./components/composant_navbar/Investir";
import Entrepreneur from "./components/composant_navbar/entrepreneur";
import Programme from "./components/composant_navbar/programme";
import VisiterChine from "./components/composant_navbar/visiterChine";
import ArticleDetail from "./components/composant_navbar/ArticleDetails";
import FormContact from "./components/composant_navbar/form_contact";
import Eventes from "./components/composant_navbar/evenement_marquants";
import Eventchine from "./components/composant_navbar/evenement_chine";
import Galery from "./components/composant_navbar/galerie";

// function App() {
//   return (
//     <Router>
//       <InnerApp />
//     </Router>
//   );
// }

function App() {
  usePageTracking();
  const fixedHeaderRef = useRef(null);
  const fixedNavbarRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const updateHeights = () => {
      const headerHeight = fixedHeaderRef.current?.offsetHeight || 81;
      const navbarHeight = fixedNavbarRef.current?.offsetHeight || 0;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--navbar-height', `${navbarHeight}px`);
      // console.log('Header height:', headerHeight, 'Navbar height:', navbarHeight); 
    };

    requestAnimationFrame(updateHeights);

    const resizeListener = () => requestAnimationFrame(updateHeights);
    window.addEventListener('resize', resizeListener);
    return () => window.removeEventListener('resize', resizeListener);
  }, [location.pathname]);

  return (
    <div className="App">
      <LanguageProvider>
      {/* Header fixe */}
      <div className="" ref={fixedHeaderRef}>
        <Header />
      </div>

      {/* Navbar fixe */}
      <div className="" ref={fixedNavbarRef}>
        <Navbar />
      </div>

      {/* Contenu principal */}
      <div className="content-wrapper">
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Accueil />} /> {/* Accueil */}
            <Route path="/visiter-benin" element={<Visiter />} /> {/* visiter */}
            <Route path="/Benin-en-chine" element={<Ambassade />} /> {/* Benin en Chine */}
            <Route path="/Equipe-diplomatique" element={<Equipe_diplomatique />} /> {/* Equipe diplo */}
            <Route path="/Consulat-honoraires" element={<Consulat_honoraires />} /> {/* Consulat honoraire */}
            <Route path="/Articles" element={<Articles />} /> {/* Articles */}
            <Route path="/article/:id/:slug" element={<ArticleDetail />} />
            <Route path="/Compte-rendus" element={<Compte_rendus />} /> {/* Compte rendus */}
            <Route path="/Communiques" element={<Communiques />} /> {/* Communiques */}
            <Route path="/Services" element={<Services />} /> {/* Services */}
            <Route path="/Cooperation-bilaterale" element={<Cooperation_bilateral />} /> {/* Coopération bilatérale */}
            <Route path="/Cooperation-multilaterales" element={<Cooperation_multilaterales />} /> {/* Coopération multilatérales */}
            <Route path="/opportunites-investissements" element={<Investir />} />
            <Route path="/formulaire-contact" element={<FormContact />} />
            <Route path="/evenements-marquants" element={<Eventes />} />
            <Route path="/evenements-chine" element={<Eventchine />} />
            <Route path="/entrepreneurs" element={<Entrepreneur />} />
            <Route path="/programme-daction-du-gouvernement" element={<Programme />} />
            <Route path="/visiter-chine" element={<VisiterChine />} />
            <Route path="/galerie" element={<Galery />} />
          </Routes>
        </div>

        {/* Bandeau de couleur */}
        <div className="section-row">
          <div className="bg-green"><div className="space"></div></div>
          <div className="bg-yellow"><div className="space"></div></div>
          <div className="bg-red"><div className="space"></div></div>
        </div>

        {/* Footer */}
        <footer className="bg-dark text-white mt-auto">
          <Footer />
        </footer>
      </div>
      </LanguageProvider>
    </div>
  );
}

export default App;